var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoxmobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 475,
    viewBox: "0 0 303 475",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 3,
    x2: 87,
    y2: 3.00001,
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 271,
    y1: 2,
    x2: 216,
    y2: 1.99999,
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 473,
    x2: 73,
    y2: 473,
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 230,
    y1: 473,
    x2: 271,
    y2: 473,
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 451,
    x2: 203,
    y2: 451,
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 29,
    x2: 3.49999,
    y2: 179,
    stroke: "#2A2A2A",
    strokeWidth: 5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 150,
    y2: -2.5,
    transform: "matrix(2.82092e-08 1 1 -6.77326e-08 302 29)",
    stroke: "#2A2A2A",
    strokeWidth: 5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 255,
    x2: 3.50001,
    y2: 448,
    stroke: "#2A2A2A",
    strokeWidth: 5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 193,
    y2: -2.5,
    transform: "matrix(-2.14316e-08 1 1 8.91527e-08 302 254)",
    stroke: "#2A2A2A",
    strokeWidth: 5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 175,
    y2: -2,
    transform: "matrix(-2.36655e-08 1 1 8.07374e-08 23 244)",
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 282,
    y1: 244,
    x2: 282,
    y2: 419,
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 5.66181,
    y1: 202.052,
    x2: 21.8727,
    y2: 245.298,
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 301.095,
    y1: 203.619,
    x2: 281.75,
    y2: 245.803,
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 33.0584,
    y1: 1.43004,
    x2: 3.39821,
    y2: 30.43,
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 269.366,
    y1: 1.53946,
    x2: 300.366,
    y2: 30.5395,
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 42.8617,
    y2: -2,
    transform: "matrix(-0.723249 -0.690587 0.830667 -0.556769 35 472.6)",
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 40.8669,
    y2: -2,
    transform: "matrix(0.70962 -0.704584 0.754847 0.655901 271 475)",
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 36.732,
    y2: -2,
    transform: "matrix(0.794791 -0.606883 0.402251 0.915529 72.7656 475)",
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    y1: -2,
    x2: 36.6964,
    y2: -2,
    transform: "matrix(-0.797211 -0.603701 -0.399459 0.916751 230.227 474.861)",
    stroke: "#2A2A2A",
    strokeWidth: 4
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 51,
    y1: 110,
    x2: 252,
    y2: 110,
    stroke: "#555555",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxmobile);
export default __webpack_public_path__ + "static/media/boxmobile.4c511a728eaaeafa9ba13890974a1e6b.svg";
export { ForwardRef as ReactComponent };